// Import all components
import Button from './button'
import Checkbox from './checkbox'
import Icon from './icon'
import Empty from './empty'
import Switch from './switch'

export {
  Button,
  Checkbox,
  Icon,
  Empty,
  Switch
}

// Vue plugin
import type { App } from 'vue'

const components = [
  Button,
  Checkbox,
  Icon,
  Empty,
  Switch
]

export default {
  install(app: App) {
    components.forEach(component => {
      if (component.name) {
        app.component(component.name, component)
      }
    })
    return app
  }
}
